export const LinkOptionsModal: string = 'LinkOptionsModal';
